import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmRackModel } from './rm-rack.model';


export class RmRackAckResponse extends GlobalResponseObject{
    data?: RmRackModel[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RmRackModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 